import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
  {
    q: "Do I need to be ready to sell before contacting you?",
    a: "No. Reaching out simply starts a conversation. We listen, share what we know, and you decide whether any next step makes sense. There is never an obligation to sell.",
  },
  {
    q: "Why did Choose Me Properties contact me?",
    a: "Our work begins with research — public records, zoning information, parcel maps, and how neighborhoods are changing. If we reached out, a property you own may relate to an opportunity we are studying, such as a potential purchase or a group of neighboring parcels. It does not mean you need to do anything, and we are glad to explain what prompted our note.",
  },
  {
    q: "What is a property assemblage?",
    a: "An assemblage is when several neighboring properties are combined into a single, larger opportunity. Individually, each parcel may have limited options; together, they can sometimes support something none of them could alone. We research these situations and communicate directly with owners when it may be relevant.",
  },
  {
    q: "Can you help me understand my property's development potential?",
    a: "Often, yes. We review zoning, lot configuration, access, and surrounding development to help owners understand what may be possible. Feasibility always depends on public regulations and site conditions, but we are glad to share what we find.",
  },
  {
    q: "Do you purchase vacant land?",
    a: "We research and evaluate land opportunities, including individual parcels, neighboring lots, and potential assemblages. Whether a purchase makes sense depends on zoning, access, site conditions, and applicable approvals — which is why we start with research and a conversation rather than assumptions.",
  },
  {
    q: "What happens after I submit my property?",
    a: "Our team reviews what you shared, does initial research, and responds using your preferred contact method. If there appears to be a fit, we discuss potential options and answer your questions. You set the pace, and starting the conversation creates no obligation.",
  },
  {
    q: "Does it cost anything to speak with you?",
    a: "No. Conversations with our team are free and carry no obligation. We are happy to share what we see — even if the right next step does not involve us.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-white py-24 sm:py-32 lg:py-40 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Owner FAQ</Eyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl text-[#111513] leading-[1.12] text-balance">
            Questions owners <span className="italic text-[#A77A50]">ask us.</span>
          </h2>
          <p className="mt-6 text-lg text-[#5C665F] leading-relaxed max-w-2xl">
            Straight answers, before you ever pick up the phone.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <Accordion type="single" collapsible className="mt-12">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-[#D9D6CE]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-7 text-left font-display text-xl sm:text-2xl text-[#111513] hover:text-[#A77A50] hover:no-underline transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="pb-7 text-base text-[#5C665F] leading-relaxed max-w-2xl"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
